/**
 * Authentication routing configuration
 *
 * Provides redirect URLs for the authentication package that work across:
 * - Development (localhost with ports)
 * - Production (path-based routing on any domain)
 *
 * This follows the same pattern as /config/app-routes.ts but is local to
 * the authentication package to maintain package independence.
 */
/**
 * Check if we're running in development mode
 */
const isDevelopment = () => {
    if (typeof window === 'undefined') {
        // Server-side or build time
        return process.env.NODE_ENV !== 'production';
    }
    // Client-side - check if running on localhost
    return window.location.hostname === 'localhost' ||
        window.location.hostname === '127.0.0.1';
};
/**
 * Get the URL to redirect to after successful authentication
 * In development: returns full URL with port (http://localhost:10000)
 * In production: returns just the path (/access)
 */
export function getAuthSuccessRedirectUrl() {
    if (isDevelopment()) {
        // Development - redirect to access app on localhost
        return 'http://localhost:10000';
    }
    else {
        // Production - use path-based routing
        // This works on any domain (platform.aurelius.com, customer domains, etc.)
        return '/access/';
    }
}
/**
 * Get the URL to redirect to on authentication error
 * Typically returns to the auth app for error display
 */
export function getAuthErrorRedirectUrl() {
    if (isDevelopment()) {
        // Development - auth app on localhost
        return 'http://localhost:10001/error';
    }
    else {
        // Production - path-based routing
        return '/auth/error';
    }
}
/**
 * Get the base URL for the auth app itself
 * Used for internal navigation within the auth flow
 */
export function getAuthBaseUrl() {
    if (isDevelopment()) {
        return 'http://localhost:10001';
    }
    else {
        return '/auth';
    }
}
